module.exports = __webpack_public_path__ + "static/media/HomeGraphic2.66372f8b.jpg";